// extracted by mini-css-extract-plugin
export var box = "_23-2";
export var checkboxControl = "_23-0";
export var checkboxRow = "_23-a";
export var checked = "_23-3";
export var descriptionSpacer = "_23-c";
export var disabled = "_23-4";
export var icon = "_23-8";
export var input = "_23-1";
export var labelSpacer = "_23-b";
export var large = "_23-7";
export var medium = "_23-6";
export var small = "_23-5";
export var text = "_23-9";